import { createTheme } from '@one-thd/sui-atomic-components';

const WinterHoliday2026PrimaryFour = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

WinterHoliday2026PrimaryFour.palette['--sui-palette-background-primary'] = '126 187 163';

export { WinterHoliday2026PrimaryFour };